import { render, staticRenderFns } from "./gift_list.vue?vue&type=template&id=083bcc02&scoped=true"
import script from "./gift_list.vue?vue&type=script&lang=js"
export * from "./gift_list.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/management.scss?vue&type=style&index=0&id=083bcc02&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083bcc02",
  null
  
)

export default component.exports